<template>
  <div>
    <section class="hero is-danger">
      <h3 class="is-size-3">
        {{ title }}
      </h3>
    </section>
    <section class="section">
      <div class="container">
        <div class="hero">
          <h1 class="is-size-1">{{ messages }}</h1>
          <div class="field">
              <button type="submit" class="button is-medium is-rounded is-success" @click="back">戻る</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      title: '',
      messages: '',
    }
  },
  mounted(){
    if(Number(this.$route.query.mode) === 1){
      this.title = "お知らせ編集"
      this.messages = "編集が完了しました。"
    }else{
      this.title = "新規お知らせ登録"
      this.messages = "登録が完了しました。"

    }
  },
  methods:{
    back(){
      this.$router.push({ path: '/' });
    }
  },
}
</script>

<style scoped>
  .hero {
    text-align: center
  }
  .file {
    margin-top: 5px;
  }
  .vertical-middle {
    position: absolute;
    top: 50%; /*親要素を起点に上から50%*/
    left: 50%;  /*親要素を起点に左から50%*/
    transform: translateY(-50%) translateX(-50%); /*要素の大きさの半分ずつを戻す*/
    -webkit-transform: translateY(-50%) translateX(-50%); 
  }
</style>